module.exports = __webpack_public_path__ + "f34c869befd7eeef7e1cd1ba135a100a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/sterling_capital_funds.png
// module id = 1915
// module chunks = 0